import { render, staticRenderFns } from "./ambulancePosition.vue?vue&type=template&id=ed75f950&scoped=true&"
import script from "./ambulancePosition.vue?vue&type=script&lang=js&"
export * from "./ambulancePosition.vue?vue&type=script&lang=js&"
import style0 from "./ambulancePosition.vue?vue&type=style&index=0&id=ed75f950&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed75f950",
  null
  
)

export default component.exports